import React from 'react';
import styles from "../BaseSimplePage/BaseSimpleItemEditorHeader.module.css";
import {Divider, Typography} from "@mui/material";

const SurveysItemEditorHeader = ({editItemId}) => {
    return (
        <div className={styles.main}>
            <Typography variant="h6" sx={{fontWeight: "bold", marginBottom: "10px"}}>
                {`Просмотр ответов (id=${editItemId})`}
            </Typography>
            <Divider component="div"/>
        </div>
    );
};

export default SurveysItemEditorHeader;